import { notifyUserReceiveTaskWW, getUserReceiveTask, setUserReceiveTask, getTaskByID, getTaskList, updateTask, deleteTask, createTask, updateTaskRecord, deleteTaskRecord, createTaskRecord } from '@/api/task'
import Vue from 'vue'

const state = {
    taskList: [],
    totalCounts: 0
}

const actions = {
  async getTaskListAction({ commit }, payload) {
    try {
      const taskList = await getTaskList(payload);
        commit('SET_TASKLIST', taskList.data)
        return taskList.data
    } catch (error) {
      throw error.message
    }
  },
    async getTaskByIDAction({ commit }, payload) {
        try {
            const task = await getTaskByID(payload)
            return task.data
        } catch (error) {
            throw error.message
        }
    },
    async createTaskAction({ commit }, payload) {
        try {
            const task = await createTask(payload);
            commit('ADD_TASK', task.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateTaskAction({ commit }, payload) {
        try {
            commit('TEMP_UPDATE_TASK', { ...payload.data, _id: payload.id})
            const task = await updateTask(payload.id, payload.data)
            commit('UPDATE_TASK', task.data)
        } catch (error) {
            commit('UPDATE_TASK_ERROR', payload.id)
            throw error.message
        }
    },
    async deleteTaskAction({ commit }, payload) {
        try {
            await deleteTask(payload)
            commit('DELETE_TASK', payload)
        } catch (error) {
            throw error.message
        }
    },
    // task record
    async createTaskRecordAction({ commit }, payload) {
        try {
            const task = await createTaskRecord(payload.taskId, payload.data);
            commit('UPDATE_TASK', task.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateTaskRecordAction({ commit }, payload) {
        try {
            const task = await updateTaskRecord(payload.recordId, payload.data)
            commit('UPDATE_TASK', task.data)
        } catch (error) {
            throw error.message
        }
    },
    async deleteTaskRecordAction({ commit }, payload) {
        try {
            const task = await deleteTaskRecord(payload.taskId, payload.data)
            commit('UPDATE_TASK', task.data)
        } catch (error) {
            throw error.message
        }
    },
    async setUserReceiveTaskAction({ commit }, payload) {
        try {
            await setUserReceiveTask(payload)
        } catch (error) {
            throw error.message
        }
    },
    async getUserReceiveTaskAction({ commit }, payload) {
        try {
            const taskList = await getUserReceiveTask(payload)
            commit('SET_TASKLIST', taskList.data)
            return taskList.data
        } catch (error) {
            throw error.message
        }
    },
    async notifyUserReceiveTaskWWAction({ commit }, payload) {
        try {
            await notifyUserReceiveTaskWW(payload)
        } catch (error) {
            throw error.message
        }
    },
}

const mutations = {
  SET_TASKLIST(state, payload) {
    state.taskList = payload.taskList;
    state.totalCounts = payload.totalCounts
  },
    ADD_TASK(state, task) {
        state.taskList.unshift(task)
        state.totalCounts++
    },
    DELETE_TASK(state, id) {
        state.taskList = state.taskList.filter(e => e._id !== id)
        state.totalCounts--
    },
    UPDATE_TASK(state, task) {
        Vue.set(state.taskList, state.taskList.findIndex(x => x._id === task._id), {...task, editError: null})
    },
    // 用于先本地修改内容（修改完后，再发布请求）
    TEMP_UPDATE_TASK(state, task) {
        const localTask = state.taskList.find(x => x._id === task._id);
        Vue.set(state.taskList, state.taskList.findIndex(x => x._id === task._id), {...localTask, ...task})
    },
    // 标记更新错误
    UPDATE_TASK_ERROR(state, id) {
        const localTask = state.taskList.find(x => x._id === id);
        Vue.set(state.taskList, state.taskList.findIndex(x => x._id === task._id), {...localTask, editError: '未修改成功'})
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}